module.exports = __webpack_public_path__ + "static/Lato-Italic-f28f2d6482446544ef1ea1ccc6dd5892.woff";